import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ToggleSwitch } from '../../../../../../../components';

const MapSettingsButton = memo(({ id, label, checked, optionLabels, mediuml, medium, xxLarge, onChange }) => {
  const { messages } = useIntl();

  const handleChange = useCallback((newChecked) => {
    onChange?.(id, newChecked);
  }, [id, onChange]);

  const resolvedMedium = !xxLarge && !medium && !mediuml;

  return (
    <ToggleSwitch
      id={id}
      medium={resolvedMedium}
      mediuml={mediuml || false}
      xxLarge={xxLarge || false}
      mapToggle
      optionLabels={optionLabels || [messages['show'], messages['hide']]}
      checked={checked}
      onChange={handleChange}
      label={label}
    />
  );
});

MapSettingsButton.displayName = 'MapSettingsButton';

export default MapSettingsButton;